import { Box, Typography } from "@mui/material";
import { History } from "@mui/icons-material";
import Lottie from "react-lottie";
import { assets } from "../../../../assets";

export const CallEmptyState = () => (
  <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100%" gap={1}>
    {/*<History
      sx={{
        fontSize: 80,
        color: "text.disabled",
        opacity: 0.4,
      }}
    /> */}

    <Box
      sx={{
        height: 110,
        width: 150,
        overflow: "hidden",
        position: "relative",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -40%) scale(2)",
          //                    ↑ antes era -50%
          transformOrigin: "center",
        }}
      >
        <Lottie
          options={{
            animationData: assets.animation.callnofound,
            loop: true,
          }}
          height={200}
          width={200}
        />
      </Box>
    </Box>
    <Typography
      variant="body1"
      color="text.secondary"
      fontWeight={500}
      sx={{
        fontSize: 15,
        fontWeight: 600,
        color: "#F19531",
        letterSpacing: "-0.01em",
        marginTop: -1,
      }}
    >
      No recent calls
    </Typography>
    <Typography variant="caption" color="text.disabled" textAlign="center" maxWidth={200}>
      Your call history will appear here
    </Typography>
  </Box>
);
